import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {FormControl} from '@angular/forms';
import {SelectValueInterface} from '@interfaces/select-value.interface';
import {LaboratoryDocumentsNamespace} from '@components/laboratory-documents/laboratory-documents.namespace';
import {LaboratoryDocument} from '@models/laboratory-document';
import {ConclusionFormDataService} from '../../services/conclusion-form-data.service';

@Component({
    selector: 'app-conclusion-form-attestation-documents',
    templateUrl: './conclusion-form-attestation-documents.component.html',
    styleUrls: ['./conclusion-form-attestation-documents.component.scss']
})
export class ConclusionFormAttestationDocumentsComponent implements OnInit {
    public documents: SelectValueInterface[] = [];

    constructor(
        private route: ActivatedRoute,
        private formDataService: ConclusionFormDataService,
    ) {
    }

    get documentsControl() {
        return this.formDataService.form.get('attestation_document_id') as FormControl;
    }

    ngOnInit() {
        const laboratoryDocuments: LaboratoryDocument[] = this.route.snapshot.data.laboratoryDocuments || [];

        this.documents = laboratoryDocuments
            .filter(doc => doc.type === LaboratoryDocumentsNamespace.DocumentTypeEnum.attestation)
            .map(doc => {
                return {
                    id: doc.id,
                    title: doc.number
                };
            });
    }
}
